import { render, staticRenderFns } from "./TextLabelThresholdEdit.vue?vue&type=template&id=148f4b98&scoped=true"
import script from "./TextLabelThresholdEdit.vue?vue&type=script&lang=js"
export * from "./TextLabelThresholdEdit.vue?vue&type=script&lang=js"
import style0 from "./TextLabelThresholdEdit.vue?vue&type=style&index=0&id=148f4b98&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148f4b98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('148f4b98')) {
      api.createRecord('148f4b98', component.options)
    } else {
      api.reload('148f4b98', component.options)
    }
    module.hot.accept("./TextLabelThresholdEdit.vue?vue&type=template&id=148f4b98&scoped=true", function () {
      api.rerender('148f4b98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/components/senior/dialog/TextLabelThresholdEdit.vue"
export default component.exports